import { render, staticRenderFns } from "./SalaryEditPtModal.vue?vue&type=template&id=3b3531ce&scoped=true&"
import script from "./SalaryEditPtModal.vue?vue&type=script&lang=js&"
export * from "./SalaryEditPtModal.vue?vue&type=script&lang=js&"
import style0 from "./SalaryEditPtModal.vue?vue&type=style&index=0&id=3b3531ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3531ce",
  null
  
)

component.options.__file = "SalaryEditPtModal.vue"
export default component.exports